/**
 * 文章拖动排序
 */
import React from 'react';
import {message, Modal, Spin} from "antd";
import ArticleSortTable from "./ArticleSortTable";
import BaseComponent from "../../../../base/BaseComponent";

export default class ArticleSortModal extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            spinning: false,
            mediaId: props.mediaId,
            columnId: props.columnId
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            mediaId: nextProps.mediaId,
            columnId: nextProps.columnId
        })
    }

    showModal() {
        this.setState({
            visible: true
        });
    }

    handleOk = () => {
        this.setState({
            spinning: true
        });
        let that = this;
        let sortIds = [];
        let sortFields = [];
        let newSortList = this.articleSortTable.state.sortList;
        newSortList.forEach((item, index) => {
            sortIds.push(item.id);
            sortFields.push(item.sort);
        });
        let params = {
            mediaFusionIds: sortIds.toString(),
            sorts: sortFields.toString(),
            columnId: that.state.columnId
        };
        this.request({
            url: "/cm-sites-mmp/mf/sort",
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                message.success("排序成功", 2, function () {
                    that.setState({
                        visible: false,
                        spinning: false
                    })
                    that.props.refreshList();
                });
            }
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false
        });
    };

    render() {
        return (
            <Modal
                title="文章排序"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={"65%"}
                destroyOnClose={true}
            >
                <Spin spinning={this.state.spinning}>
                    <ArticleSortTable mediaId={this.state.mediaId} columnId={this.state.columnId} orderField={"sort"}
                                      ref={(articleSortTable) => this.articleSortTable = articleSortTable}/>
                </Spin>
            </Modal>
        )
    }
}